import(/* webpackMode: "eager" */ "/opt/prowel-livekit/web/app/page.tsx");
